module.exports = __webpack_public_path__ + "img/teutoniques_1_cover.2c8a9f97.jpg";